/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function CodigoVinculacion(e) {
  let t = (0, ReactCompiler.c)(7),
    { codigo: n } = e,
    r;
  t[0] === n
    ? (r = t[1])
    : ((r = n.length === 8 ? `${n.slice(0, 4)}-${n.slice(4)}` : n),
      (t[0] = n),
      (t[1] = r));
  let i = r,
    a;
  t[2] === i
    ? (a = t[3])
    : ((a = (
        <p
          className={`font-mono text-3xl font-semibold tracking-[0.2em] text-(--text-h)`}
          aria-label={`Código de vinculación`}
          children={i}
        />
      )),
      (t[2] = i),
      (t[3] = a));
  let o;
  t[4] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((o = (
        <p
          className={`text-xs text-(--text)`}
          children={`En el teléfono del bot: WhatsApp → Dispositivos vinculados → Vincular un dispositivo → «Vincular con el número de teléfono», y escribe este código. Si vence, aparece otro solo.`}
        />
      )),
      (t[4] = o))
    : (o = t[4]);
  let s;
  return (
    t[5] === a
      ? (s = t[6])
      : ((s = (
          <div
            className={`flex flex-col items-center gap-2 rounded-xl border border-(--border) p-4 text-center`}
            children={[a, o]}
          />
        )),
        (t[5] = a),
        (t[6] = s)),
    s
  );
}
